(function () {
  'use strict';

  var settings = window.BellunaUkSizing || {};
  var bandSizeMap = {
    '70': '32',
    '75': '34',
    '80': '36',
    '85': '38',
    '90': '40',
    '95': '42',
    '100': '44',
    '105': '46'
  };
  var modal;
  var previousOverflow = '';

  function forEach(items, callback) {
    Array.prototype.forEach.call(items || [], callback);
  }

  function isBandSizeSelect(select) {
    var matches = 0;

    forEach(select.options, function (option) {
      if (bandSizeMap[String(option.textContent || '').trim()]) matches += 1;
    });

    return matches >= 4;
  }

  function localizeBandSizes(root) {
    forEach((root || document).querySelectorAll('select'), function (select) {
      if (!isBandSizeSelect(select)) return;

      forEach(select.options, function (option) {
        var currentLabel = String(option.textContent || '').trim();
        if (bandSizeMap[currentLabel]) option.textContent = bandSizeMap[currentLabel];
      });
    });
  }

  function getUkRecommendation(underbustInches, bustInches) {
    if (
      !isFinite(underbustInches) ||
      !isFinite(bustInches) ||
      underbustInches <= 0 ||
      bustInches <= 0
    ) {
      return '';
    }

    var underbust = Math.round(underbustInches * 2.54);
    var bust = Math.round(bustInches * 2.54);
    var difference = bust - underbust;

    if (difference >= 8.5 && difference <= 21.5 && underbust >= 65 && underbust <= 68) return 'XS';
    if (difference >= 8.5 && difference <= 13.9 && underbust >= 69 && underbust <= 74) return 'XS';
    if (difference >= 14 && difference <= 21.5 && underbust >= 69 && underbust <= 74) return 'S';
    if (difference >= 8.5 && difference <= 13.9 && underbust >= 75 && underbust <= 79) return 'S';
    if (difference >= 14 && difference <= 21.5 && underbust >= 75 && underbust <= 79) return 'M';
    if (difference >= 8.5 && difference <= 16.4 && underbust >= 80 && underbust <= 84) return 'M';
    if (difference >= 16.5 && difference <= 21.5 && underbust >= 80 && underbust <= 84) return 'L';
    if (difference >= 8.5 && difference <= 16.4 && underbust >= 85 && underbust <= 89) return 'L';
    if (difference >= 16.5 && difference <= 21.5 && underbust >= 85 && underbust <= 89) return 'XL';
    if (difference >= 11.5 && difference <= 16.4 && underbust >= 90 && underbust <= 94) return 'XL';
    if (difference >= 16.5 && difference <= 21.5 && underbust >= 90 && underbust <= 94) return '2XL';
    if (difference >= 11.5 && difference <= 16.4 && underbust >= 95 && underbust <= 99) return '2XL';
    if (difference >= 16.5 && difference <= 21.5 && underbust >= 95 && underbust <= 99) return '3XL';
    if (difference >= 11.5 && difference <= 16.4 && underbust >= 100 && underbust <= 104) return '3XL';

    if (
      (difference >= 16.5 && difference <= 21.5 && underbust >= 100 && underbust <= 104) ||
      (difference > 21.5 && underbust >= 90) ||
      (underbust > 104 && difference >= 8.5)
    ) {
      return 'Based on your measurements, we recommend trying our Full Coverage Bra.';
    }

    return settings.noSizeMessage;
  }

  function getProductImage() {
    var productImage = document.querySelector('main img.image-magnify-none');
    var kiwiImage = document.querySelector('.ks-calculator-image img');
    var image = productImage || kiwiImage;
    return image ? String(image.currentSrc || image.src || '') : '';
  }

  function setActiveTab(tabName) {
    forEach(modal.querySelectorAll('[data-belluna-uk-tab]'), function (button) {
      var selected = button.getAttribute('data-belluna-uk-tab') === tabName;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    forEach(modal.querySelectorAll('[data-belluna-uk-panel]'), function (panel) {
      panel.hidden = panel.getAttribute('data-belluna-uk-panel') !== tabName;
    });
  }

  function updateResult() {
    var underbust = Number(modal.querySelector('[data-belluna-uk-underbust]').value);
    var bust = Number(modal.querySelector('[data-belluna-uk-bust]').value);
    var result = getUkRecommendation(underbust, bust);
    var resultBox = modal.querySelector('[data-belluna-uk-result-box]');
    var resultText = modal.querySelector('[data-belluna-uk-result]');

    resultText.textContent = result;
    resultBox.hidden = !result;
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = previousOverflow;
  }

  function openModal() {
    if (!modal) createModal();

    var image = modal.querySelector('[data-belluna-uk-product-image]');
    var calculator = modal.querySelector('.belluna-uk-size-modal__calculator');
    var imageUrl = getProductImage();
    calculator.classList.toggle('is-no-image', !imageUrl);
    if (imageUrl) {
      image.onerror = function () {
        calculator.classList.add('is-no-image');
      };
      image.src = imageUrl;
    }

    setActiveTab('calculator');
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.hidden = false;
    window.setTimeout(function () {
      modal.querySelector('[data-belluna-uk-underbust]').focus();
    }, 50);
  }

  function createModal() {
    var style = document.createElement('style');
    style.id = 'belluna-uk-sizing-styles';
    style.textContent = [
      '.belluna-uk-size-modal[hidden]{display:none!important}',
      '.belluna-uk-size-modal{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(0,0,0,.7)}',
      '.belluna-uk-size-modal__dialog{position:relative;width:min(980px,100%);max-height:calc(100vh - 48px);overflow:auto;background:#fff;border-radius:12px;color:#2e2e2e;box-shadow:0 24px 80px rgba(0,0,0,.28)}',
      '.belluna-uk-size-modal__header{text-align:center;padding:22px 60px 16px;border-bottom:1px solid #bbb}',
      '.belluna-uk-size-modal__header h2{margin:0 0 5px;font-size:26px;line-height:1.2}',
      '.belluna-uk-size-modal__header p{margin:0;font-size:18px;letter-spacing:.04em}',
      '.belluna-uk-size-modal__close{position:absolute;right:20px;top:14px;border:0;background:transparent;font-size:38px;line-height:1;cursor:pointer;color:#26313b}',
      '.belluna-uk-size-modal__tabs{display:grid;grid-template-columns:1fr 1fr;padding:0 18px}',
      '.belluna-uk-size-modal__tab{border:0;border-bottom:2px solid #bbb;background:#fff;padding:15px 10px 10px;font:inherit;font-size:18px;color:#888;cursor:pointer}',
      '.belluna-uk-size-modal__tab.is-active{border-bottom:4px solid #287ff0;color:#303030}',
      '.belluna-uk-size-modal__panel{padding:28px}',
      '.belluna-uk-size-modal__calculator{display:grid;grid-template-columns:minmax(220px,34%) 1fr;gap:28px;align-items:center}',
      '.belluna-uk-size-modal__calculator.is-no-image{grid-template-columns:1fr}',
      '.belluna-uk-size-modal__calculator.is-no-image .belluna-uk-size-modal__product-image{display:none}',
      '.belluna-uk-size-modal__product-image{width:100%;max-height:420px;object-fit:cover;border-radius:4px}',
      '.belluna-uk-size-modal__form{background:#f2f2f2;padding:24px}',
      '.belluna-uk-size-modal__form h3{margin:0 0 20px;font-size:27px}',
      '.belluna-uk-size-modal__field{display:block;margin-top:18px}',
      '.belluna-uk-size-modal__label{display:block;font-weight:700;font-size:19px;line-height:1.3}',
      '.belluna-uk-size-modal__help{display:block;margin:4px 0 8px;font-size:17px}',
      '.belluna-uk-size-modal__input{width:100%;min-height:54px;border:1px solid #c9c9c9;border-radius:6px;background:#fff;padding:10px 14px;font:inherit;font-size:18px}',
      '.belluna-uk-size-modal__result{margin-top:22px;padding:18px;background:#fff;border-left:4px solid #8e7165}',
      '.belluna-uk-size-modal__result strong{display:block;margin-bottom:6px;font-size:17px}',
      '.belluna-uk-size-modal__result span{font-size:19px}',
      '.belluna-uk-size-modal__chart{display:block;width:auto;max-width:100%;max-height:calc(100vh - 260px);margin:0 auto}',
      '@media(max-width:700px){.belluna-uk-size-modal{align-items:flex-start;padding:10px}.belluna-uk-size-modal__dialog{width:100%;height:auto;max-height:calc(100vh - 20px);max-height:calc(100dvh - 20px);border-radius:7px}.belluna-uk-size-modal__header{padding:15px 44px 10px}.belluna-uk-size-modal__header h2{font-size:17px}.belluna-uk-size-modal__header p{font-size:17px}.belluna-uk-size-modal__close{right:12px;top:9px;font-size:36px}.belluna-uk-size-modal__tabs{padding:0 14px}.belluna-uk-size-modal__tab{padding:11px 5px 7px;font-size:15.5px;line-height:1.15}.belluna-uk-size-modal__panel{padding:12px 16px 30px}.belluna-uk-size-modal__calculator{grid-template-columns:1fr}.belluna-uk-size-modal__product-image{display:none}.belluna-uk-size-modal__form{padding:0 2px 2px}.belluna-uk-size-modal__form h3{margin:0;padding:14px 16px 9px;font-size:18px;line-height:1.25}.belluna-uk-size-modal__fields{margin:0 2px;background:#fff;padding:1px 16px 14px}.belluna-uk-size-modal__field{margin-top:12px}.belluna-uk-size-modal__label{font-size:14px;line-height:1.25}.belluna-uk-size-modal__help{margin:3px 0 6px;font-size:14px;line-height:1.25}.belluna-uk-size-modal__input{height:42px;min-height:42px;padding:7px 9px;font-size:16px;-webkit-appearance:textfield;appearance:textfield}.belluna-uk-size-modal__input::-webkit-inner-spin-button,.belluna-uk-size-modal__input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.belluna-uk-size-modal__result{margin-top:14px;padding:11px}.belluna-uk-size-modal__result strong{font-size:14px}.belluna-uk-size-modal__result span{font-size:16px}.belluna-uk-size-modal__chart{max-height:calc(100dvh - 185px)}}'
    ].join('');
    document.head.appendChild(style);

    modal = document.createElement('div');
    modal.className = 'belluna-uk-size-modal';
    modal.hidden = true;
    modal.innerHTML = [
      '<div class="belluna-uk-size-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="belluna-uk-size-title">',
      '<button class="belluna-uk-size-modal__close" type="button" aria-label="Close size guide">&times;</button>',
      '<header class="belluna-uk-size-modal__header"><h2 id="belluna-uk-size-title">Wireless Comfort Bra</h2><p>Size Charts</p></header>',
      '<div class="belluna-uk-size-modal__tabs" role="tablist">',
      '<button class="belluna-uk-size-modal__tab is-active" type="button" role="tab" aria-selected="true" data-belluna-uk-tab="calculator">Calculate my size</button>',
      '<button class="belluna-uk-size-modal__tab" type="button" role="tab" aria-selected="false" data-belluna-uk-tab="chart">Size chart</button>',
      '</div>',
      '<section class="belluna-uk-size-modal__panel" data-belluna-uk-panel="calculator">',
      '<div class="belluna-uk-size-modal__calculator">',
      '<img class="belluna-uk-size-modal__product-image" data-belluna-uk-product-image alt="Wireless Comfort Bra">',
      '<div class="belluna-uk-size-modal__form">',
      '<h3>Find your perfect size</h3>',
      '<div class="belluna-uk-size-modal__fields">',
      '<label class="belluna-uk-size-modal__field"><span class="belluna-uk-size-modal__label">Measure your underbust circumference (in)</span><span class="belluna-uk-size-modal__help">Measure directly under your bust.</span><input class="belluna-uk-size-modal__input" type="number" min="0" step="0.1" inputmode="decimal" autocomplete="off" aria-label="Underbust circumference in inches" data-belluna-uk-underbust></label>',
      '<label class="belluna-uk-size-modal__field"><span class="belluna-uk-size-modal__label">Measure your bust circumference (in)</span><span class="belluna-uk-size-modal__help">Measure around the fullest part of your bust.</span><input class="belluna-uk-size-modal__input" type="number" min="0" step="0.1" inputmode="decimal" autocomplete="off" aria-label="Bust circumference in inches" data-belluna-uk-bust></label>',
      '<div class="belluna-uk-size-modal__result" aria-live="polite" data-belluna-uk-result-box hidden><strong>Recommended size</strong><span data-belluna-uk-result></span></div>',
      '</div></div></div></section>',
      '<section class="belluna-uk-size-modal__panel" data-belluna-uk-panel="chart" hidden><img class="belluna-uk-size-modal__chart" src="' + settings.chartImage + '" alt="Wireless Comfort Bra UK size chart"></section>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);

    modal.querySelector('.belluna-uk-size-modal__close').addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    forEach(modal.querySelectorAll('[data-belluna-uk-tab]'), function (button) {
      button.addEventListener('click', function () {
        setActiveTab(button.getAttribute('data-belluna-uk-tab'));
      });
    });
    forEach(modal.querySelectorAll('input'), function (input) {
      input.addEventListener('input', updateResult);
    });
  }

  function init() {
    createModal();
    localizeBandSizes(document);

    window.BellunaUkSizingReady = 'v4';

    document.addEventListener('click', function (event) {
      var target = event.target;
      var link;

      if (target && target.nodeType !== 1) target = target.parentElement;
      if (target && typeof target.closest === 'function') {
        link = target.closest('a[href="#bra-size-finder"]');
      }
      if (!link) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openModal();
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });

    new MutationObserver(function (mutations) {
      forEach(mutations, function (mutation) {
        forEach(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) localizeBandSizes(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (window.location.pathname.indexOf('/products/') === -1) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
